import React from "react";
import Row from "react-bootstrap/Row";
import { useAppSelector } from "../../../hooks";
import { crmBasicProfileSelector } from "../../../redux/slices/Member/member";

import {
  Container,
  Greetings,
  PointsTile,
  StatusTile,
} from "./ProfileRewardsHelpers";

const ProfileRewards: React.FC = () => {
  const crmBasicProfile = useAppSelector(crmBasicProfileSelector);
  const { rewardPoints, memberId } = crmBasicProfile;
  // const [profileTypeHelpText, setProfileTypeHelpText] = React.useState('');
  const greetings = crmBasicProfile.rewardPoints ? (
    <Greetings>My Rewards</Greetings>
  ) : (
    ""
  );

  // React.useEffect(() => {
  //   if (crmProfile.profileType) {
  //     let helpText = '';
  //     switch (crmProfile.profileType.toLowerCase()) {
  //       case 'member':
  //         helpText = '0-5 NIGHTS';
  //         break;
  //       case 'preffered':
  //         helpText = '6-11 NIGHTS';
  //         break;
  //       case 'elite':
  //         helpText = '12+ NIGHTS';
  //         break;

  //     }
  //     setProfileTypeHelpText(helpText);
  //   }
  // }, [crmProfile]);

  return (
    <>
      {crmBasicProfile && (
        <>
          {greetings}
          <Container>
            <Row className="mb-4 g-2">
              <PointsTile rewardPoints={rewardPoints} memberId={memberId} />
              <StatusTile profileType={crmBasicProfile.profileType} />
            </Row>
            {/* <Row className="my-4 g-2" >
            <RedeemPonts />
          </Row> */}
          </Container>
        </>
      )}
    </>
  );
};
export default ProfileRewards;
